import { createSelector } from '@reduxjs/toolkit';
import { itemsSelector } from '../../../../features/commerce/context/cart/cart-selector.js';
import { createCartKey } from './headless-cart.js';
export function itemSelector(cartState, item) {
    return cartState.cart[createCartKey(item)];
}
export const totalQuantitySelector = createSelector(itemsSelector, (items) => items.reduce((prev, cur) => prev + cur.quantity, 0));
export const totalPriceSelector = createSelector(itemsSelector, (items) => items.reduce((prev, cur) => prev + cur.price * cur.quantity, 0));
